import SectionLabel from "@/components/base/SectionLabel";
import { servicesData } from "@/mocks/homeData";
import { useNavigate } from "react-router-dom";

export default function ServicesSection() {
  const navigate = useNavigate();

  return (
    <section id="services" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16 reveal">
          <SectionLabel label={servicesData.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {servicesData.title}
          </h2>
        </div>

        <div className="space-y-12 md:space-y-16">
          {servicesData.items.map((service, idx) => (
            <div
              key={service.id}
              className={`reveal grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 items-center ${
                idx % 2 === 1 ? "lg:flex-row-reverse" : ""
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              {/* Image */}
              <div className={`${idx % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-background-200">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-3 left-3 md:top-4 md:left-4">
                    <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs md:text-sm font-medium">
                      {service.badge}
                    </span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className={`${idx % 2 === 1 ? "lg:order-1" : ""}`}>
                <span className="inline-block text-xs md:text-sm font-medium tracking-wider text-primary-500 font-label mb-1">
                  {service.subtitle}
                </span>
                <h3 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-900 mb-3 md:mb-4">
                  {service.title}
                </h3>

                <div className="mb-3 md:mb-4">
                  <span className="inline-block px-3 py-1 rounded-md bg-primary-50 text-primary-700 text-xs md:text-sm font-medium">
                    {service.target}
                  </span>
                </div>

                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5 md:mb-6">
                  {service.description}
                </p>

                <div className="mb-5 md:mb-6">
                  <p className="text-xs md:text-sm font-medium text-foreground-600 mb-2 md:mb-2.5 font-label">
                    主な支援内容
                  </p>
                  <ul className="space-y-1.5 md:space-y-2">
                    {service.features.map((feature) => (
                      <li
                        key={feature}
                        className="flex items-start gap-2 text-sm md:text-base text-foreground-700"
                      >
                        <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <button
                  onClick={() => navigate(`/service/${service.id}`)}
                  className="inline-flex items-center gap-1.5 text-sm md:text-base font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  詳しく見る
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}